import Immutable from 'seamless-immutable'
import { getLocalState } from './selectors'
import { forceUpdate } from '../threeviewer/ui'
import * as actionTypes from '../action-types'

const DISPOSE = 'undoRedo/DISPOSE'
const MAX_HISTORY = 40

const getHeadCommand = (commands) => (commands.length ? commands[0] : undefined)

export function undo () {
  return (dispatch, getState) => {
    const { undos } = getLocalState(getState())
    const command = getHeadCommand(undos)

    if (command !== undefined && command.undo) {
      command.undo()
      dispatch({ type: actionTypes.UNDO, payload: { affectsDirty: command.affectsDirty } })
    }
    dispatch(forceUpdate())
  }
}

export function redo () {
  return (dispatch, getState) => {
    const { redos } = getLocalState(getState())
    const command = getHeadCommand(redos)

    if (command !== undefined && command.execute) {
      command.execute()
      dispatch({ type: actionTypes.REDO, payload: { affectsDirty: command.affectsDirty } })
    }
    dispatch(forceUpdate())
  }
}

export function addCommand (command) {
  return (dispatch) => dispatch({ type: actionTypes.ADD_COMMAND, payload: { command } })
}

export function dispose () {
  return {
    type: DISPOSE
  }
}

const initialState = Immutable({
  redos: [],
  undos: [],
})

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.UNDO: {
      const newUndos = state.undos.length === 1 ? [] : state.undos.slice(1)
      return state.merge({
        undos: newUndos,
        redos: [state.undos[0]].concat(state.redos)
      })
    }

    case actionTypes.REDO: {
      const newUndos = state.redos.length > 0 ? [state.redos[0]].concat(state.undos) : state.undos
      return state.merge({
        undos: newUndos,
        redos: state.redos.length === 1 ? [] : state.redos.slice(1)
      })
    }

    case actionTypes.ADD_COMMAND:
      return state.merge({
        undos: [action.payload.command].concat(state.undos).slice(0, MAX_HISTORY),
        redos: []
      })

    case DISPOSE:
      return initialState

    default:
      return state
  }
}
